import { IconLineage } from '../../../common/icons';
import SummaryCard from '../../../common/components/summary-card';
import { envelopeData } from '../../../core/network/envelope';
import { useRecipientsList } from '../contexts/recipients';
import { statusLabel } from '../utils/status';

// TSS vite/03 — resumen de parcerías para el home. Reusa el hook de la feature
// (useRecipientsList) con un limit chico: el home solo muestra el total y un
// preview de las primeras receptoras, con CTA a la vista completa.
// Contract: GET public/recipients — respuesta COMPUESTA, viene en el sobre
// público (0052). Se lee data vía envelopeData() (tolerante a plano también),
// el mismo helper que usa el overview.

const PREVIEW = 3;

export default function ParceriasSummary() {
    const { data, isLoading, isError, error } = useRecipientsList({ limit: PREVIEW });

    const payload = envelopeData(data);
    const items = Array.isArray(payload.items) ? payload.items : [];
    const total = payload.pagination?.total ?? payload.pagination?.count ?? items.length;

    const count = isLoading || isError
        ? null
        : `${total} receptora${total === 1 ? '' : 's'}`;

    return (
        <SummaryCard
            icon={<IconLineage />}
            title="Parcerías"
            count={count}
            to="/parcerias"
            ctaLabel="Ver todas mis parcerías →"
        >
            {isLoading ? (
                <p className="summary-card__state">Cargando parcerías…</p>
            ) : isError ? (
                <p className="summary-card__state summary-card__state--error">
                    {error?.message || 'No se pudieron cargar tus parcerías'}
                </p>
            ) : !items.length ? (
                <p className="summary-card__state">
                    Aún no tienes receptoras registradas en tus parcerías.
                </p>
            ) : (
                <ul className="summary-card__list">
                    {items.map((recipient) => (
                        <li key={recipient.id} className="summary-card__row">
                            <span className="summary-card__row-main">
                                <span className="summary-card__row-name">{recipient.name}</span>
                                <span className="summary-card__row-sub">
                                    Nº {recipient.number}
                                    {recipient.farm?.name ? ` · ${recipient.farm.name}` : ''}
                                </span>
                            </span>
                            <span
                                className={`summary-card__status ${recipient.status === 2 ? '' : 'summary-card__status--muted'}`}
                            >
                                {statusLabel(recipient.status)}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </SummaryCard>
    );
}
